import React, { useState } from 'react'
import Dashboard from './Dashboard'
import Schedule from './Schedule'
import Assignments from './Assignments'
import Attendance from './Attendance'
import Exams from './Exams'
import { useResponsiveContext } from '../context/ResponsiveContext'

const tabs = [
  { id: 'dashboard', label: 'لوحة المعلومات' },
  { id: 'schedule', label: 'الجدول' },
  { id: 'assignments', label: 'الواجبات' },
  { id: 'attendance', label: 'الحضور' },
  { id: 'exams', label: 'الامتحانات' },
]

export default function MainTabs() {
  const { isMobile } = useResponsiveContext()
  const [activeTab, setActiveTab] = useState('dashboard')

  let content = null
  if (activeTab === 'dashboard') content = <Dashboard />
  else if (activeTab === 'schedule') content = <Schedule />
  else if (activeTab === 'assignments') content = <Assignments />
  else if (activeTab === 'attendance') content = <Attendance />
  else if (activeTab === 'exams') content = <Exams />

  return (
    <div dir="rtl" style={{ minHeight: '100vh', background: '#f3f4f6', display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          borderBottom: '1px solid #e5e7eb',
          background: '#ffffff',
          position: 'sticky',
          top: 0,
          zIndex: 10,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: 8,
            padding: 8,
          }}
        >
          {tabs.map(tab => {
            const selected = tab.id === activeTab
            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: '8px 12px',
                  borderRadius: isMobile ? 10 : 999,
                  border: selected ? '1px solid #2563eb' : '1px solid #e5e7eb',
                  background: selected ? '#2563eb' : '#ffffff',
                  color: selected ? '#ffffff' : '#111827',
                  fontSize: 14,
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                  width: isMobile ? '100%' : 'auto',
                  textAlign: 'center',
                }}
              >
                {tab.label}
              </button>
            )
          })}
        </div>
      </div>
      <div style={{ flex: 1 }}>{content}</div>
    </div>
  )
}
